
import fetch from 'isomorphic-unfetch';

import { API_TELL_US_MORE_DROP_DOWN_DATA, API_TELL_US_MORE_GIFTS_DATA, SECTION_EXPANDED_CLASS } from '../constants';
import JraEncodeDecodeModule from './JraEncodeDecodeModule';
import JraAddComponent from '../JraAddComponent';
import { isCustomValidInput } from '../helpers';


const PREFERRED_DEALERS = 'Preferred Dealers';
export default class JraTellUsMore extends JraEncodeDecodeModule {
  constructor(element, encodeDecodeKey) {
    super(encodeDecodeKey);
    this.element = element;

    this.dropDownData = undefined;
    this.dropDownOne = undefined;
    this.dropDownTwo = undefined;
    this.giftDataLoaded = false;
    this.giftData = undefined;
    this.hasValidDealerId = false;
    this.dealerId = undefined;
    this.dealer = undefined;

    this.initJraTellUsMore();
  }

  initJraTellUsMore() {
    this.dropDownOne = this.element.querySelector('[data-jra-tell-us-more-drop-down-one]');
    this.dropDownTwo = this.element.querySelector('[data-jra-tell-us-more-drop-down-two]');
    this.dropDownOnePlaceholder = this.element.dataset.jraTellUsMoreDropDownOnePlaceholder || '';
    this.dropDownTwoPlaceholder = this.element.dataset.jraTellUsMoreDropDownTwoPlaceholder || '';
    this.dropDownTwoFieldset = this.element.querySelector('[data-jra-tell-us-more-drop-down-two-fieldset]');
    this.giftCode = this.element.dataset.jraTellUsMoreGiftCode || 'NULL';
    this.giftOptionsContainer = this.element.querySelector('[data-jra-tell-us-more-gift-options]');
    this.giftPlaceholder = this.element.dataset.jraTellUsMoreGiftPlaceholder || '';
    this.dropDownGift = this.element.querySelector('[data-jra-tell-us-more-drop-down-gift]');
    this.tellUsMoreSection = document.getElementById('tellUsMoreSection');

    if (this.dropDownOne) {
      this.dropDownOne.addEventListener('change', this.onDropDownOneChange);
    }

    if (this.dropDownTwo) {
      this.dropDownTwo.addEventListener('change', this.onDropDownTwoChange);
    }

    this.fetchDropDownOneData();
  }

  encode(modules) {
    super.encode(modules);

    if (this.dropDownData) {
      modules[this.key].dropDownData = this.dropDownData;
    }

    if (this.giftData) {
      modules[this.key].giftData = this.giftData;
    }
  }

  decode() {
    super.decode();
    const module = this.getEncodedSessionData();
    if (!module) return;

    if (module.dropDownData) {
      this.dropDownData = module.dropDownData;
      this.renderDropDownOne();
      super.decode();
      this.onDropDownOneChange();
      super.decode();
      if (module.giftData) {
        this.giftData = module.giftData;
        this.giftDataLoaded = true;
        this.renderGiftOptions();
      }

      super.decode();
    }
  }

  checkDealerId() {
    const dealers = this.dropDownData.map(item => item.Suboptions).flat();
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const lowerCaseParams =
      new URLSearchParams([...params].map(([key, value]) => [key.toLowerCase(), value]));
    this.dealerId = lowerCaseParams.get('dealerid');
    if (dealers) {
      const dealer = dealers.find(item => item.Value === this.dealerId);
      if (dealer) {
        this.hasValidDealerId = true;
        this.dealer = { ...dealer };
      }
    }
  }

  fetchDropDownOneData() {
    fetch(`${API_TELL_US_MORE_DROP_DOWN_DATA}`)
      .then(response => response.json())
      .then((json) => {
        if (!this.dropDownData) { // check not to overwrite decoded data
          this.dropDownData = json.TellUsMoreDD;
          this.checkDealerId();
          if (this.hasValidDealerId) {
            this.tellUsMoreSection.classList.add('JraForm_sectionInner-hidden');
          }
          this.renderDropDownOne();
        }
        if (__DEVELOPMENT__) {
          console.log('getData parsed json', json);
        }
      }).catch((error) => {
        if (__DEVELOPMENT__) {
          console.log('getData parsing failed', error);
        }
      });
  }


  fetchGiftData() {
    fetch(`${API_TELL_US_MORE_GIFTS_DATA}`)
      .then(response => response.json())
      .then((json) => {
        if (!this.giftData) {
          this.giftData = json.GiftDD;
          this.giftDataLoaded = true;
          this.renderGiftOptions();
        }
        if (__DEVELOPMENT__) {
          console.log('getData parsed json', json);
        }
      }).catch((error) => {
        if (__DEVELOPMENT__) {
          console.log('getData parsing failed', error);
        }
      });
  }


  getDropDownTwoData(oneValue) {
    if (oneValue === '') return [];
    const oneData = this.dropDownData.find(datum => datum.Value === oneValue);
    if (oneData.Suboptions && oneData.Suboptions.length > 0) {
      return oneData.Suboptions;
    }

    return [];
  }


  onDropDownOneChange = () => {
    const data = this.getDropDownTwoData(this.dropDownOne.value);
    this.renderDropDownTwo(data);
  }


  onDropDownTwoChange = () => {
    if (this.dropDownTwo.value === this.giftCode) {
      this.giftOptionsContainer.style.height = 'auto';
      // required for the validation
      this.giftOptionsContainer.classList.add(SECTION_EXPANDED_CLASS);
      // required as decoding will treat dropDownTwoFieldset as JraAddComponent and disable inputs
      // if closed
      JraAddComponent.enableFormInputs(this.giftOptionsContainer);
      if (!this.giftDataLoaded) {
        this.fetchGiftData();
      }
    } else {
      // required for the validation
      this.giftOptionsContainer.classList.remove(SECTION_EXPANDED_CLASS);
      // required as decoding will treat dropDownTwoFieldset as JraAddComponent and disable inputs
      // if closed
      JraAddComponent.disableFormInputs(this.giftOptionsContainer);
      this.giftOptionsContainer.style.height = '0';
    }
  }


  renderDropDownOne() {
    let html = this.hasValidDealerId
      ? `<option disabled value="">${this.dropDownOnePlaceholder}</option>`
      : `<option selected disabled value="">${this.dropDownOnePlaceholder}</option>`;

    html = this.dropDownData.reduce((str, datum) => {
      const htmlOption =
        this.hasValidDealerId && datum.Value === PREFERRED_DEALERS
          ? `${str}<option selected value="${datum.Value}">${datum.Text}</option>`
          : `${str}<option value="${datum.Value}">${datum.Text}</option>`;
      return htmlOption;
    }, html);

    this.dropDownOne.innerHTML = html;
    if (this.hasValidDealerId) {
      this.dropDownOne.value = PREFERRED_DEALERS;
      isCustomValidInput(this.dropDownOne);
      this.renderDropDownTwo(
        this.dropDownData.find(item => item.Text === PREFERRED_DEALERS).Suboptions,
      );
    }
  }


  renderDropDownTwo(data) {
    let html = `<option selected disabled value="">${this.dropDownTwoPlaceholder}</option>`;
    if (data.length > 0) {
      this.dropDownTwoFieldset.classList.add(SECTION_EXPANDED_CLASS); // required for validation
      this.dropDownTwoFieldset.classList.remove('JraForm_fieldset-hidden');
      // required as decoding will treat dropDownTwoFieldset as JraAddComponent and disable inputs
      // if closed
      JraAddComponent.enableFormInputs(this.dropDownTwoFieldset);
    } else {
      html = '';
      this.dropDownTwoFieldset.classList.remove(SECTION_EXPANDED_CLASS); // required for validation
      this.dropDownTwoFieldset.classList.add('JraForm_fieldset-hidden');
      // required as decoding will treat dropDownTwoFieldset as JraAddComponent and disable inputs
      // if closed
      JraAddComponent.disableFormInputs(this.dropDownTwoFieldset);
    }

    if (this.hasValidDealerId) {
      this.dropDownTwo.innerHTML = `<option selected value=${this.dealer.Value}>${this.dealer.Text}</option>`;
    } else {
      html = data.reduce(
        (str, datum) => `${str}<option value="${datum.Value}">${datum.Text}</option>`,
        html,
      );
      this.dropDownTwo.innerHTML = html;
    }
    this.onDropDownTwoChange();
  }


  renderGiftOptions() {
    let html = `<option selected disabled>${this.giftPlaceholder}</option>`;
    html = this.giftData.reduce((str, datum) => `${str}<option value="${datum.Value}">${datum.Text}</option>`, html);

    this.dropDownGift.innerHTML = html;
  }
}
